<template>
  <div class="editPassword">
    <div
      class="publicTitle display-flex justify-content-space-between align-items-center"
    >
      <h5 class="h5">
        <img src="../../assets/img/titleLine.png" alt /> 密码修改
      </h5>
    </div>
    <div class="mid">
      <div class="step display-flex justify-content-center align-items-center">
        <div class="step1 display-flex align-items-center">
          <span
            class="sFrame"
            :style="{ background: step2 ? '#222' : '#31af58' }"
          ></span>
          <p :style="{ color: step2 ? '#222' : '#31af58' }">手机验证</p>
        </div>
        <div class="line"></div>
        <div class="step2 display-flex align-items-center">
          <span
            class="sFrame"
            :style="{ background: step2 ? '#31af58' : '#222' }"
          ></span>
          <p :style="{ color: step2 ? '#31af58' : '#222' }">新密码输入</p>
        </div>
      </div>
      <div class="from">
        <Form
          v-if="!step2"
          class="head-login"
          ref="from"
          :model="userData"
          :rules="rules"
          :label-width="80"
          :hide-required-mark="true"
        >
          <div>
            <div class="phone">
              电话号码
              <p v-if="info.phone">
                {{
                  info.phone.slice(0, 3) +
                    "****" +
                    info.phone.slice(info.phone.length - 4, info.phone.length)
                }}
              </p>
            </div>
            <div class="display-flex justify-content-space-between">
              <div class="code">
                <FormItem ref="code" label="验证码" prop="code">
                  <Input
                    v-model="userData.code"
                    placeholder="请输入验证码"
                  ></Input>
                </FormItem>
              </div>
              <div class="send">
                <FormItem>
                  <Button
                    :disabled="btnDisabled"
                    type="primary"
                    @click="handleSendCode('from')"
                    >{{ codeBtnText }}</Button
                  >
                </FormItem>
              </div>
            </div>
          </div>

          <div id="save">
            <FormItem>
              <Button
                class="confirm"
                type="primary"
                @click="handleSubmit('from')"
                >确认</Button
              >
            </FormItem>
          </div>
        </Form>
        <Form
          v-else
          class="head-login"
          ref="from1"
          :model="paw"
          :rules="rule"
          :label-width="80"
          :hide-required-mark="true"
        >
          <div>
            <FormItem label="新密码" prop="password">
              <Input
                type="password"
                v-model="paw.password"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </div>
          <div id="save">
            <FormItem>
              <Button
                class="confirm"
                type="primary"
                @click="handleSubmitstep1('from1')"
                >确认</Button
              >
            </FormItem>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { postData, showLoading, EventBus } from "../../assets/api/api.js";
export default {
  name: "editPassword",
  components: {},
  data() {
    return {
      codeBtnText: "点击发送",
      btnDisabled: false,
      step2: false,
      userData: {
        phone: "",
        code: "",
      },
      paw: {
        password: "",
      },
      rule: {
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          {
            type: "string",
            min: 6,
            message: "密码长度不能少于6位数",
            trigger: "blur",
          },
        ],
      },
      rules: {
        code: [{ required: true, message: "验证码不能为空", trigger: "blur" }],
      },
      info: {},
    };
  },

  created() {
    this.loadData();
  },
  mounted() {},
  computed: {},
  methods: {
    loadData() {
      var params = {};
      showLoading();
      postData("student/find", params).then((res) => {
        this.info = res.data;
        EventBus.$emit("getData", this.info);
      });
    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          var params = {
            phone: this.info.phone,
            vercode: this.userData.code,
          };
          postData("student/checkSmsCode", params).then((res) => {
            this.step2 = true;
          });
        }
      });
    },
    handleSubmitstep1(name) {
      this.$refs[name].validateField("password", (valid) => {
        if (!valid) {
          var params = {
            password: this.paw.password,
          };
          postData("student/update", params).then((res) => {
            this.$Message.success("修改成功");
            localStorage.removeItem("master");
            sessionStorage.removeItem("master");
            this.$store.commit("setMaster", {
              user: {
                username: "",
              },
              token: {
                token: "",
              },
            });
            EventBus.$emit("getToten");
            setTimeout(() => {
              this.$router.replace({
                path: "/",
              });
              EventBus.$emit("login");
            }, 1000);
          });
        }
      });
    },
    handleSendCode(name) {
      if (!this.info.phone) {
        this.$Message.warning("请先去绑定手机号码");
        return;
      }
      var params = {
        phone: this.info.phone,
        type: 6,
      };

      postData("student/sendSmsCode", params).then((res) => {
        this.$Message.success("发送成功,请注意查收");
        var time = 60;
        this.codeBtnText = time + "s后重发";
        var timer = setInterval(() => {
          if (time <= 0) {
            clearInterval(timer);
            this.codeBtnText = "点击发送";
            this.btnDisabled = false;
            return;
          }
          time--;
          this.codeBtnText = time + "s后重发";
          this.btnDisabled = true;
        }, 1000);
      });
      // this.$refs[name].validateField("phone", (valid) => {
      //   if (!valid) {
      //   } else {
      //   }
      // });
    },
  },
};
</script>
<style>
.editPassword #save {
  text-align: left;
}
.editPassword .ivu-input {
  height: 36px;
}
.editPassword .send .ivu-form-item-content {
  margin-left: 0 !important;
}
.editPassword .send .ivu-btn-primary {
  color: rgba(153, 153, 153, 1);
  border: 1px solid #dedbde;
  background: #dddddd;
}
.editPassword .send button {
  height: 36px;
}
.editPassword .confirm {
  margin-top: 10px;
  width: 120px;
  height: 40px;
  line-height: 40px;
  background: rgba(49, 175, 88, 1);
  border-radius: 4px;
  border: none;
}
</style>
<style lang="scss" scoped>
.editPassword {
  .phone {
    margin-bottom: 20px;
    width: 300px;
    text-align: left;
    margin-left: 10px;
    p {
      margin-left: 25px;
      display: inline-block;
    }
  }
  text-align: center;

  .step {
    margin-bottom: 55px;
    margin-top: 65px;
    .line {
      margin-right: 12px;
      margin-left: 12px;
      height: 1px;
      width: 57px;
      background: #a09da0;
    }
    .sFrame {
      margin-right: 8px;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
    }
    .step1 {
      p {
        color: #31af58;
      }
      .sFrame {
        background: #31af58;
      }
    }
    .step2 {
      p {
        color: #222222;
      }
      .sFrame {
        background: #222222;
      }
    }
  }
  .code {
    width: 300px;
  }
  .send {
    width: 90px;
  }
  .from {
    display: inline-block;
    margin-bottom: 115px;
    width: 480px;
    input {
      width: 50px;
    }
  }
}
</style>
